import React, { useState } from 'react';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const Product = ({ item, addToCart, loading = false }) => {
  // hide thumbnails for single image
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Combina proImg e images in un unico array
  const allImages = item.images || [];

  const handlePrevImage = () => {
    if (allImages.length > 0) {
      setCurrentImageIndex((prev) =>
        prev === 0 ? allImages.length - 1 : prev - 1
      );
    }
  };

  const handleNextImage = () => {
    if (allImages.length > 0) {
      setCurrentImageIndex((prev) =>
        prev === allImages.length - 1 ? 0 : prev + 1
      );
    }
  };

  return (

    <div className="row">
      <div className="col col-lg-5 col-12">
        <div className="shop-single-slider" style={{ position: 'relative' }}>
          <style>{`
            .shop-single-slider::before {
              display: none !important;
            }
            .shop-single-slider img[alt] {
              display: block;
            }
          `}</style>
          <div className="slider-nav">
            {/* Carosello con tutte le immagini */}
            {allImages.length > 0 && (
              <div className="mt-4">
                <div style={{ position: 'relative', marginBottom: '10px' }}>
                  <Zoom>
                    <img
                      src={`${process.env.REACT_APP_PANEL_URL}/storage/${allImages[currentImageIndex].image_path}`}
                      alt={allImages[currentImageIndex].original_filename}
                      style={{ maxWidth: '100%', display: 'block' }}
                    />
                  </Zoom>

                  {/* Frecce navigazione */}
                  {allImages.length > 1 && (
                    <>
                      <button
                        onClick={handlePrevImage}
                        style={{
                          position: 'absolute',
                          left: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          color: 'white',
                          border: 'none',
                          padding: '10px 15px',
                          cursor: 'pointer',
                          borderRadius: '3px',
                          fontSize: '18px',
                          zIndex: 10
                        }}
                      >
                        ‹
                      </button>
                      <button
                        onClick={handleNextImage}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          color: 'white',
                          border: 'none',
                          padding: '10px 15px',
                          cursor: 'pointer',
                          borderRadius: '3px',
                          fontSize: '18px',
                          zIndex: 10
                        }}
                      >
                        ›
                      </button>
                    </>
                  )}
                </div>

                {/* Indicatore immagini */}
                {allImages.length > 1 && (
                  <div style={{ textAlign: 'center', fontSize: '12px', color: '#666' }}>
                    {currentImageIndex + 1} / {allImages.length}
                  </div>
                )}

                {/* Thumbnails - show only if multiple images */}
                {allImages.length > 1 && (
                  <div className="row" style={{ marginTop: '10px', gap: '5px' }}>
                    {allImages.map((image, idx) => (
                      <div
                        key={idx}
                        onClick={() => setCurrentImageIndex(idx)}
                        style={{
                          cursor: 'pointer',
                          opacity: idx === currentImageIndex ? 1 : 0.6,
                          border: idx === currentImageIndex ? '2px solid #333' : '1px solid #ccc',
                          padding: '2px',
                          flex: '0 0 calc(25% - 5px)',
                          maxWidth: 'calc(25% - 5px)'
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_PANEL_URL}/storage/${image.image_path}`}
                          alt={image.original_filename}
                          style={{ maxWidth: '100%', display: 'block' }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col col-lg-7 col-12">
        <div className="product-details">
          <h2>{item.title}</h2>
          {/*<div className="product-rt">*/}
            {/*<div className="rating">*/}
            {/*  <i className="fa fa-star"></i>*/}
            {/*  <i className="fa fa-star"></i>*/}
            {/*  <i className="fa fa-star"></i>*/}
            {/*  <i className="fa fa-star"></i>*/}
            {/*  <i className="fa fa-star-o"></i>*/}
            {/*</div>*/}
            {/*<span>(25 customer reviews)</span>*/}
          {/*</div>*/}
          <div className="price">
            <span className="current">€{item.price}</span>
            {item.delPrice && <span className="old">€{item.delPrice}</span>}
          </div>
          <div dangerouslySetInnerHTML={{ __html: item.description }} />

          {/* Badge Categorie */}
          {item.categories && item.categories.length > 0 && (
            <div style={{ marginTop: '20px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {item.categories.map((cat, idx) => (
                <span
                  key={idx}
                  style={{
                    display: 'inline-block',
                    padding: '5px 12px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '15px',
                    fontSize: '13px',
                    color: '#333'
                  }}
                >
                  {cat.name}
                </span>
              ))}
            </div>
          )}

          <div className="product-option">
            <div className="product-row">
              <button
                className="theme-btn"
                onClick={() => addToCart(item)}
                disabled={loading}
              >
                {loading ? 'Aggiungendo al carrello...' : 'Aggiungi al carrello'}
              </button>
              <div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Product;
